export const RECEIVE_FILEROUTETYPES = 'RECEIVE_FILEROUTETYPES';
export const REQUEST_FILEROUTETYPES = 'REQUEST_FILEROUTETYPES';
export const REQUEST_FILEROUTETYPES_COMPLETE = 'REQUEST_FILEROUTETYPES_COMPLETE';
export const REQUEST_FILEROUTETYPES_FAILED = 'REQUEST_FILEROUTETYPES_FAILED';
export const LOADING_ERROR = 'LOADING_ERROR';
export const SAVE_FILEROUTETYPES_LOADING = 'SAVE_FILEROUTETYPES_LOADING';
export const RECEIVE_SAVE_RESPONSE = 'RECEIVE_SAVE_RESPONSE';
export const SAVE_FILEROUTETYPES_COMPLETED = 'SAVE_FILEROUTETYPES_COMPLETED';
